export const defaultMultiFilter = (rows, columnIds, filterValue) => {
    // Filters only if filters are selected
    return Array.isArray(filterValue)
        ? filterValue.length === 0
            ? rows
            : rows.filter((row) => filterValue.includes(row.values[columnIds[0]]))
        : rows.filter((row) => filterValue == row.values[columnIds[0]]);
};
